import { render, staticRenderFns } from "./lightapplication.vue?vue&type=template&id=5b5455df&scoped=true"
import script from "./lightapplication.vue?vue&type=script&lang=js"
export * from "./lightapplication.vue?vue&type=script&lang=js"
import style0 from "./lightapplication.vue?vue&type=style&index=0&id=5b5455df&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5b5455df",
  null
  
)

export default component.exports